import { EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
//can be used as common service for emr
export class CoversheetService {
 
  constructor(
    public baseService: BaseService,
    public alerts: AlertsService,
    public loaderService?: LoaderService,
    public router?: Router,
    public route?: ActivatedRoute,
    ) { }
  
    private _isLinkOpened = new BehaviorSubject<boolean>(false);
    isLinkOpened$ = this._isLinkOpened.asObservable();
  
    setLinkOpened() {
      this._isLinkOpened.next(true);
    }
  
    setLinkClosed() {
      this._isLinkOpened.next(false);
    }
  
    get isLinkOpened(): boolean {
      return this._isLinkOpened.value;
    }

  
}